import { createTheme, CreateThemeOptions } from "@rneui/themed";
import { Easing } from "react-native-reanimated";

export const themeConfig: CreateThemeOptions = {
  mode: "light",
  lightColors: {
    primary: "#000AD2",
    textPrimary: "#1C252E",
    textSecondary: "#637381",
    background: "#F6F6F6",
    activeBackground: "#E6E7FB",
    borderGray: "#CDCDCD",
    inputBorder: "#E0E6F0",
    success: "#00C95C",
    danger: "#FF4444",
    error: "#FF4444",
    warning: "#FFA500",
    white: "#FFFFFF",
    black: "#000000",
    lightWarning: "#F7ECD8",
    lightGreen: "#04B488",
    darkGreen: "#03795C",
    purple: "#E6E7FB",
    dotColor: "#979591",
    linearGradient1: "#A8DBFD",
    linearGradient2: "#A8DBFD66",
    darkBlue: "#000458",
    extraLightBlue: "#E6E7FB",
    darkPrimary: "#000458",
    cardBackground: "#FFFFFF",
    badgeBackground: "#F7ECD8",
    shadowColor: "#000000",
    navText: "#64748B",
    separatorColor: "#CBD5E1",
    arrowBackground: "rgba(255, 255, 255, 0.3)",
    infoIconBackground: "rgba(148, 163, 184, 0.3)",
    lowRisk: "#22C55E",
    moderateRisk: "#F59E0B",
    highRisk: "#EF4444",
    veryHighRisk: "#DC2626",
    positiveChange: "#22C55E",
    negativeChange: "#EF4444",
    MutualFundCardlinearGradient1: "#A8DBFD",
    MutualFundCardlinearGradient2: "rgba(168, 219, 253, 0.4)",
    sipAmountText: "#1C252E",
    sipProgressBarBg: "#E0F2FE",
    outlinedButtonBg: "#E6E7FB",
    modalBackground: "rgba(0,0,0,0.5)",
    gray: "#999",
    loader: "#D7EBF9",
    LinegradientColor1: "rgba(0, 5, 119, 0.31)",
    LinegradientColor2: "rgba(255, 255, 255, 0.31)",
    primaryHolderGradient1: "rgba(230, 231, 251, 0)",
    nextStepper: "#E0F1FD",
    nomineeBlue: "#3893CC",
    nomineeYellow: "#FFB800",
    nomineeIndigo: "#6B73FF",
    nomineeLightBlue: "#4A90E2",
    nomineeRed: "#FF6B6B",
    boxColor: "#A8DBFD33",
    delete: "#f14366",
    lightgray: "#eee",
    moreButtonBackground: "#63738114",
    paymentSuccess: "#00A841",
    paymentFailed: "#BF3333",
    deActivateButton: "#1C252E0F",
    ActivateButton: "#A8DBFD66",
    trendyBg: "#FEF5D6",
    lightBlue: "#6287C5",
    linearGradientStart: "#0108A9",
    calendarBackground: "#FFFFFF",
    calendarBorder: "#E5E5E5",
    calendarButtonBorder: "#007AFF",
    calendarButtonBackground: "#007AFF",
    calendarButtonText: "#FFFFFF",
    highRisked: "#FF44441F",
    modrateRisk: "#FFA5001F",
    lowRisked: "#0D9C701F",
    paymentTabBgcolor: "#B0B3F1",
    inactiveTabBgcolor: "#F8F8F8",
    status: "#36B2FF",
    stepperDone: "#04B488",
    sendingText: "#373737",
    simText: "#212529",
    primaryBlue: "#0d6efd",
    scrollableDisable: "#3333331F",
    Skip: "#BF7C00",
    simSelectedBg: "#e3f2fd",
    verifiedText: "#059669",
    lastTransaction: "#F3F4FE",
    addNomineeButtonBg: ":rgba(230, 231, 251, 1)",
    searchBarbg: "#FFFFFF29",
    deleteRed: "#F143663D",
    jointHolder: "#6284C0",
    activeNavRoutebackground: "rgba(168, 219, 253, 0.4)",
    boxShadow: "#00000012",
    progressBar1Color: "#001A7A",
    progressBar2Color: "#009BFA",
    graphPinkLine: "#FF05E2",
    graphPinkLight: "#F5DFE7",
    assetMoneyMarket: "#667AFF",
    assetMutualFundUnits: "#67C2F8",
    assetCashEquivalent: "#6C29A9",
    assetGovernmentSecurity: "#AE23A4",
    heroBackground: "#BDD7E6",
    panLabelBackground: "#F5F5F5",
    readOnlyInputBackground: "#55555529",
    hero2Background: "#6081BF",
    whiteOpacity31: "rgba(255, 255, 255, 0.31)",
    DayReturnColorText: "rgba(4, 180, 136, 1)",
    portfolioTableBg: " rgba(0, 0, 0, 0.08)",
    xirrAndAbolutePortfolio: " rgba(13, 185, 117, 1)",
  },
  darkColors: {
    primary: "#4C8DFF",
    textPrimary: "#FFFFFF",
    textSecondary: "#A0AEC0",
    background: "#0B0B2A",
    activeBackground: "#1C1F4A",
    borderGray: "#2D2E3F",
    inputBorder: "#3A3A5A",
    success: "#00C95C",
    danger: "#FF5E5E",
    warning: "#F9B84A",
    white: "#FFFFFF",
    black: "#000000",
    lightWarning: "#3A3225",
    lightGreen: "#0ACF83",
    darkGreen: "#03795C",
    purple: "#2A2A5F",
    dotColor: "#5A5A7F",
    linearGradient1: "#000458",
    linearGradient2: "#020C69",
    darkBlue: "#000458",
    extraLightBlue: "#1E1E4A",
    darkPrimary: "#1A1B3F",
    cardBackground: "#1E1E2E",
    badgeBackground: "#2B2B40",
    shadowColor: "#000000",
    navText: "#A0AEC0",
    separatorColor: "#2D2E3F",
    arrowBackground: "rgba(255, 255, 255, 0.15)",
    infoIconBackground: "rgba(255, 255, 255, 0.1)",
    lowRisk: "#4ADE80",
    moderateRisk: "#FACC15",
    highRisk: "#F87171",
    veryHighRisk: "#DC2626",
    positiveChange: "#4ADE80",
    negativeChange: "#F87171",
    MutualFundCardlinearGradient1: "#000AD2",
    MutualFundCardlinearGradient2: "#14163C",
    sipAmountText: "#E0E6EC",
    sipProgressBarBg: "#2A2A4F",
    outlinedButtonBg: "#2E2E50",
    modalBackground: "rgba(0,0,0,0.7)",
    gray: "#777",
    loader: "#202040",
    LinegradientColor1: "rgba(255, 255, 255, 0.05)",
    LinegradientColor2: "rgba(255, 255, 255, 0.15)",
    primaryHolderGradient1: "rgba(0, 0, 50, 0.8)",
    nextStepper: "#243B7B",
    nomineeBlue: "#4F9EE3",
    nomineeYellow: "#FACC15",
    nomineeIndigo: "#818CF8",
    nomineeLightBlue: "#60A5FA",
    nomineeRed: "#F87171",
    boxColor: "rgba(168, 219, 253, 0.1)",
    delete: "#F14366",
    lightgray: "#2E2E3A",
    moreButtonBackground: "rgba(255,255,255,0.05)",
    paymentSuccess: "#00C95C",
    paymentFailed: "#FF5E5E",
    deActivateButton: "rgba(255,255,255,0.05)",
    ActivateButton: "rgba(76,141,255,0.2)",
    trendyBg: "#2C2C40",
    lightBlue: "#6287C5",
    linearGradientStart: "#000AD2",
    calendarBackground: "#1E1E2E",
    calendarBorder: "#2D2E3F",
    calendarButtonBorder: "#4C8DFF",
    calendarButtonBackground: "#4C8DFF",
    calendarButtonText: "#FFFFFF",
    highRisked: "rgba(255,68,68,0.1)",
    modrateRisk: "rgba(255,165,0,0.1)",
    lowRisked: "rgba(13,156,112,0.1)",
    paymentTabBgcolor: "#202040",
    inactiveTabBgcolor: "#141426",
    status: "#36B2FF",
    stepperDone: "#00C95C",
    sendingText: "#E0E6EC",
    simText: "#A0AEC0",
    primaryBlue: "#4C8DFF",
    scrollableDisable: "rgba(255,255,255,0.05)",
    Skip: "#FACC15",
    searchBarbg: "#FFFFFF29",
    progressBar1Color: "#001A7A",
    progressBar2Color: "#009BFA",
    graphPinkLine: "#FF05E2",
    graphPinkLight: "#F5DFE7",
    assetMoneyMarket: "#667AFF",
    assetMutualFundUnits: "#67C2F8",
    assetCashEquivalent: "#6C29A9",
    assetGovernmentSecurity: "#AE23A4",
    heroBackground: "#BDD7E6",
    panLabelBackground: "#2B2B40",
    readOnlyInputBackground: "#FFFFFF1A",
    hero2Background: "#6081BF",
    whiteOpacity31: "rgba(255, 255, 255, 0.31)",
    whiteOpacity40: "rgba(250, 247, 247, 0.4)",
  },
  components: {
    BottomSheet: {
      backdropStyle: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
    },
    Icon: (props: any, theme: any) => ({
      color: theme?.mode === "light" ? "#001B31" : "#FEFEFE",
    }),
    Image: {
      placeholderStyle: {
        backgroundColor: "transparent",
      },
    },
    Button: {
      radius: 10,
      buttonStyle: {
        paddingVertical: 12,
      },
      titleStyle: {
        fontSize: 12,
        fontWeight: "500",
      },
      disabledStyle: {
        backgroundColor: "lightgray",
      },
    },
    CheckBox: {
      textStyle: {
        fontSize: 12,
        color: "#747474",
      },
      containerStyle: {
        backgroundColor: "transparent",
        margin: 0,
        paddingHorizontal: 0,
      },
    },
    Switch: {},
    Text: {
      style: {
        fontSize: 14,
        fontWeight: "500",
        fontFamily: "Graphik-Regular",
      },
    },
    Skeleton: {
      skeletonStyle: {
        opacity: 0.2,
      },
    },
  },
  animation: {
    durationFast: 100,
    durationNormal: 200,
    durationSlow: 400,
    curveEaseInOut: Easing.bezier(0.25, 0.1, 0.25, 1),
  },
  fontSize: {
    xSmall: 10,
    small: 12,
    normal: 14,
    large: 16,
    xLarge: 18,
    x2Large: 20,
    x3Large: 24,
    x4Large: 28,
    x5Large: 32,
    x6Large: 36,
  },
};

const theme = createTheme(themeConfig);

export default theme;
